import { request } from '@/utils/request/request';
// 用电量报表
export function eleList(data) {
  return request({
    url: 'api/report/v1/JPTQ_GetList_YongDianLiang',
    method: 'GET',
    params: data,
  });
}
// 用户报表
export function userReports(data) {
  return request({
    url: 'api/report/v1/JPTQ_GetList_YongDianLiang_YongHu',
    method: 'GET',
    params: data,
  });
}
// 变压器报告列表
export function transReports(data) {
  return request({
    url: 'api/report/v1/JPTQ_GetStatementData_Transformer',
    method: 'GET',
    params: data,
  });
}
// 公共区域列表
export function publicReports(data) {
  return request({
    url: 'api/report/v1/JPTQ_GetStatementData_PublicArea',
    method: 'GET',
    params: data,
  });
}
// 获取报告类型列表
export function getReportTypes(params) {
  return request({
    url: 'api/report/v1/GetReportTypeList',
    method: 'GET',
    params,
  });
}
// 获取报告内容
export function getReportDetail(params) {
  return request({
    url: 'api/report/v1/GetReports',
    method: 'GET',
    params,
  });
}
